@if (adDetails.adStatus === AdStatus.NotStarted) {
  <p class="alert alert-warning">
    <i class="me-2 text-warning fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
    <span>Обявата ще бъде активна от </span>
    <span>
        <strong>{{ adDetails.startDateTime | date: 'dd.MM.yyyy' }}</strong> година в
        <strong>{{ adDetails.startDateTime | date: 'HH:mm' }} </strong> часа.
      </span>
  </p>
} @else if (adDetails.adStatus === AdStatus.CompletedWithoutDeal) {
  <p class="alert alert-secondary">
    <i class="me-2 text-secondary fa-solid fa-triangle-exclamation"></i>
    <span>Обявата приключи без сключена сделка.</span>
  </p>
} @else if (adDetails.adStatus === AdStatus.CompletedWithDirectSale || adDetails.adStatus === AdStatus.CompletedWithAuctionWin) {
  @if (adDetails.isUserOwner) {
    <div class="shadow border rounded-3 bg-white">
      <header class="p-3 bg-light border-bottom rounded-top-3">
        <h5 class="m-0 text-primary-emphasis">
          <i class="me-2 fa-solid"
             [ngClass]="adDetails.adStatus === AdStatus.CompletedWithDirectSale ? 'fa-handshake' : 'fa-gavel'">
          </i>
          <span>Вашата обява приключи със сключена сделка.</span>
        </h5>
      </header>
      <main class="p-3 border-bottom">
        <div>
          <p class="mb-1">
            Потребителят
            <a class="btn-link fw-bold text-decoration-none"
               [routerLink]="[appRoutes.root, appRoutes.profile, adDetails.buyerId]">{{ adDetails.buyerUsername }}</a>
            {{ adDetails.adStatus === AdStatus.CompletedWithDirectSale ? 'потвърди покупката на артикула: ' : 'е победител в наддаването за артикул: ' }}
            <strong>{{ adDetails.title }}</strong>.
          </p>
          <p>Свържете се с купувача, за да уточните детайлите по доставката и заплащането на артикула.</p>
          <p class="m-0 text-muted small text-end">
            {{ adDetails.boughtOn | date: 'dd.MM.yyyy' }} г. {{ adDetails.boughtOn | date: 'HH:mm' }}ч.
          </p>
        </div>
      </main>
      <footer class="p-3 bg-light rounded-bottom-3">
        <div class="row g-3 justify-content-end">
          <div class="col-12 col-md-auto d-flex justify-content-end gap-3 flex-column flex-md-row">
            <button type="button"
                    class="btn btn-nz-primary"
                    (click)="onOpenUserFeedbackModal(DealParticipantType.Seller)">
              <i class="me-2 fa-regular fa-thumbs-up"></i>
              <span>Оценете купувача</span>
            </button>
            <button class="btn btn-nz-primary"
                    (click)="onOpenConversationMessageModal(DealParticipantType.Seller)">
              <i class="me-2 fa-regular fa-envelope"></i>
              <span>Съобщение до купувача</span>
            </button>
            <div class="dropdown">
              <a class="w-100 btn btn-light border text-muted dropdown-toggle" href="#" role="button"
                 data-bs-toggle="dropdown"
                 aria-expanded="false">
                Още
              </a>
              <ul class="dropdown-menu dropdown-menu-end rounded-end-0 shadow">
                <li>
                  <button class="dropdown-item"
                          (click)="insertUserReport(this.adDetails.buyerId, this.adDetails.buyerUsername)">
                    <i class="dropdown-item-icon text-warning fas fa-exclamation-triangle" aria-hidden="true"></i>
                    Докладвай потребителя
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  } @else if (adDetails.isUserBuyer) {
    <div class="shadow border rounded-3 bg-white ">
      <header class="p-3 bg-light border-bottom rounded-top-3">
        <h5 class="m-0 text-primary-emphasis">
          <i class="me-2 fa-solid"
             [ngClass]="adDetails.adStatus === AdStatus.CompletedWithDirectSale ? 'fa-handshake' : 'fa-gavel'">
          </i>
          <span>
            {{ adDetails.adStatus === AdStatus.CompletedWithDirectSale ? 'Успешно сключена сделка.' : 'Спечелен аукцион.' }}
          </span>
        </h5>
      </header>
      <main class="p-3 border-bottom">
        <div>
          <p class="mb-1">
            {{ adDetails.adStatus === AdStatus.CompletedWithDirectSale ? 'Вие потвърдихте покупката на артикул: ' : 'Вие спечелихте наддаването за артикул: ' }}
            <strong>{{ adDetails.title }}</strong>.
          </p>
          <p>Свържете се с продавача, за да уточните детайлите по доставката и заплащането на артикула.</p>
          <p class="m-0 text-muted small text-end">
            {{ adDetails.boughtOn | date: 'dd.MM.yyyy' }} г. {{ adDetails.boughtOn | date: 'HH:mm' }} ч.
          </p>
        </div>
      </main>
      <footer class="p-3 bg-light rounded-bottom-3">
        <div class="row g-3 justify-content-end">
          <div class="col-12 col-md-auto d-flex justify-content-end gap-3 flex-column flex-md-row">
            <button type="button"
                    class="btn btn-nz-primary"
                    (click)="onOpenUserFeedbackModal(DealParticipantType.Buyer)">
              <i class="me-2 fa-regular fa-thumbs-up"></i>
              <span>Оценете продавача</span>
            </button>
            <button class="btn btn-nz-primary"
                    (click)="onOpenConversationMessageModal(DealParticipantType.Buyer)">
              <i class="me-2 fa-regular fa-envelope"></i>
              <span>Съобщение до продавача</span>
            </button>
            <div class="dropdown">
              <a class="w-100 btn btn-light border text-muted dropdown-toggle" href="#" role="button"
                 data-bs-toggle="dropdown"
                 aria-expanded="false">
                Още
              </a>
              <ul class="dropdown-menu dropdown-menu-end rounded-end-0 shadow">
                <li>
                  <button class="dropdown-item"
                          (click)="insertUserReport(this.adDetails.sellerId, this.adDetails.sellerUsername)">
                    <i class="dropdown-item-icon text-warning fas fa-exclamation-triangle" aria-hidden="true"></i>
                    Докладвай потребителя
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  } @else {
    <p class="alert alert-secondary">
      <i class="me-2 text-secondary fa-solid fa-triangle-exclamation"></i>
      <span>Обявата приключи със сключена сделка.</span>
    </p>
  }
} @else if (adDetails.isBidder) {
  @if (adDetails.isCurrentAuctionWinner) {
    <p class="alert alert-primary">
      <i class="me-2 text-primary fa-solid fa-check"></i>
      <span>Вие сте начело в наддаването с
        <strong>{{ adDetails.price.toFixed(2) }}</strong> лева от предложени
        <strong>{{ adDetails.bidLimitAmount.toFixed(2) }}</strong> лева.
      </span>
    </p>
  } @else {
    <p class="alert alert-danger">
      <i class="me-2 text-danger fa-solid fa-triangle-exclamation"></i>
      <span>Бяхте изместени в наддаването.</span>
    </p>
  }
}
